import React, { Component } from 'react'
import map from 'lodash/map'
import gql from 'graphql-tag'
import { Query } from 'react-apollo'

import Loader from 'components/Loader'
import { Container, Header, Table, Button } from 'semantic-ui-react'

const sortTypes = {
  LIKES: 'likes',
  VIEWS: 'views',
  BOOKMARKS: 'bookmarks',
  SHARES: 'shares',
}

const ASCENDING = 'ascending'
const DESCENDING = 'descending'

const WEB_HOST = process.env.WEB_HOST

class ContentMetrics extends Component {
  state = {
    sortType: '',
    sortAscending: false,
    tag: '',
  }

  handleSortChange = sort => event => {
    this.setState(state => {
      const { sortType, sortAscending } = state

      return sort === sortType
        ? { sortAscending: !sortAscending }
        : { sortType: sort, sortAscending }
    })
  }
  handleTagChange = tag => event => this.setState({ tag })

  renderTable() {
    const { tag, sortType, sortAscending } = this.state
    const sort = sortType
      ? `${sortType}-${sortAscending ? ASCENDING : DESCENDING}`
      : ''
    const variables = { tag, sort }
    return (
      <Query query={CONTENT_METRICS_QUERY} variables={variables}>
        {({ data, loading }) => {
          if (loading) {
            return <Loader />
          }

          return (
            <Table>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell width={4}>Title</Table.HeaderCell>
                  <Table.HeaderCell>Tags</Table.HeaderCell>
                  <Table.HeaderCell>
                    <Button onClick={this.handleSortChange(sortTypes.VIEWS)}>
                      Views
                    </Button>
                  </Table.HeaderCell>
                  <Table.HeaderCell>
                    <Button onClick={this.handleSortChange(sortTypes.LIKES)}>
                      Likes
                    </Button>
                  </Table.HeaderCell>
                  <Table.HeaderCell>
                    <Button
                      onClick={this.handleSortChange(sortTypes.BOOKMARKS)}
                    >
                      Bookmarks
                    </Button>
                  </Table.HeaderCell>
                  <Table.HeaderCell>
                    <Button onClick={this.handleSortChange(sortTypes.SHARES)}>
                      Shares
                    </Button>
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Header>

              <Table.Body>
                {map(data.contentMetrics, this.renderRow)}
              </Table.Body>
            </Table>
          )
        }}
      </Query>
    )
  }

  renderRow = ({
    target: { id, title, tags },
    views,
    likes,
    shares,
    bookmarks,
  }) => {
    if (!tags) {
      tags = []
    }
    return (
      <Table.Row key={id}>
        <Table.Cell>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={`${WEB_HOST}/article/${id}`}
          >
            {title}
          </a>
        </Table.Cell>
        <Table.Cell style={{ display: 'flex', flexDirection: 'column' }}>
          {tags.map(tag => (
            <Button
              key={tag.name}
              basic
              onClick={this.handleTagChange(tag.name)}
            >
              {tag.name}
            </Button>
          ))}
        </Table.Cell>
        <Table.Cell>{views}</Table.Cell>
        <Table.Cell>{likes}</Table.Cell>
        <Table.Cell>{bookmarks}</Table.Cell>
        <Table.Cell>{shares}</Table.Cell>
      </Table.Row>
    )
  }

  render() {
    const { tag } = this.state
    return (
      <Container>
        <Header as="h1" content="Content Metrics" />

        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Button
              disabled={!tag}
              negative
              onClick={() => this.setState({ tag: '' })}
            >
              Clear Tag Filter
            </Button>
            {tag ? <p>Filtering Tag: {tag}</p> : <p>No Tag Filter</p>}
          </div>

          <Button primary onClick={() => this.props.history.push('/contents')}>
            Back
          </Button>
        </div>

        {this.renderTable()}
      </Container>
    )
  }
}

export const CONTENT_METRICS_QUERY = gql`
  query ContentMetricsQuery($sort: String, $tag: String) {
    contentMetrics(sort: $sort, tag: $tag) {
      target {
        id
        title
        tags {
          name
        }
      }
      views
      likes
      shares
      bookmarks
    }
  }
`

export default ContentMetrics
